import { ApiCall } from "../helper/axios";
/**
 * Utility Service
 * Handles common utility API calls
 */
class UtilityService {
    /**
     * Fetch all active paid media clients
     */
    async getActiveClients(token, status = 'active', moduleName) {
        const headers = { Authorization: token };
        if (moduleName) {
            headers['x-module-key'] = moduleName;
        }
        const response = await ApiCall("GET", `/api/utility/clients/active?status=${status}`, "", headers);
        if (response && "data" in response && response.status === 200) {
            return response.data;
        }
        throw new Error("Failed to fetch active clients");
    }
    /**
     * Fetch client by ID
     */
    async getClientById(clientId, token) {
        const response = await ApiCall("GET", `/api/utility/clients/${clientId}`, "", {
            Authorization: token,
        });
        if (response && "data" in response && response.status === 200) {
            return response.data;
        }
        throw new Error("Failed to fetch client");
    }
    /**
     * Fetch clients by filter
     */
    async getClientsByFilter(filter, token) {
        const response = await ApiCall("POST", "/api/utility/clients/filter", filter, {
            Authorization: token,
        });
        if (response && "data" in response && response.status === 200) {
            return response.data;
        }
        throw new Error("Failed to fetch clients");
    }
    /**
 * Update client visibility (Bulk)
 */
    async updateClientVisibility(clientIds, client_visible, token) {
        const response = await ApiCall("POST", "/api/utility/clients/visibility", { clientIds, client_visible }, {
            Authorization: token,
        });
        if (response && "data" in response && response.status === 200) {
            return response.data;
        }
        throw new Error("Failed to update client visibility");
    }
}
// Export singleton instance
export const utilityService = new UtilityService();
